import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loadings from "../../components/Loadings/Loadings";
import fetchData from "utils/fetchData";
import stringUtilities from "utils/stringUtilities";

const SimulationResultDetails = () => {
  const { id, applicantId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState();

  const loadData = async () => {
    try {
      try {
        var pResult = await fetchData.Post('/api/exam/GetBackgroundInventigationeResults', {
          ApplicantID: applicantId,
          JobPositionID: id,
          QuestionSetName: 'Simulation'
        });
        pResult?.questions?.map(vItem => {
          pResult?.raters?.map(vRater => {
            var pScore = vRater.answers[vItem.questionID];
            pScore = stringUtilities.CDec2(pScore);
            if (pScore != 0)
              vItem.total = stringUtilities.CDec2(vItem.total) + stringUtilities.CDec2(pScore);
          });

          pResult.total = stringUtilities.CDec2(pResult.total) + stringUtilities.CDec2(vItem.total);
        });
        setResult(pResult);
      } catch (error) {
        console.log('Error in GetBackgroundInventigationeResults: ' + error)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  const navigate = useNavigate();
  return (
    <>
      {isLoading ? (
        <Loadings />
      ) : (
        <div className="">
          <button
            onClick={() => navigate(-1)}
            className="whitespace-nowrap hover:underline hover:text-blue-800 underline-offset-2"
          >
            Back
          </button>
          
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Applicant: {result?.applicantName}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Job Position: {result?.jobPosition?.name}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Date Posted: {stringUtilities.FormatDate(result?.jobPosition?.postingDate)}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Applicant Deadline: {stringUtilities.FormatDate(result?.jobPosition?.applicationDeadline)}
            </h1>
          </div>

          <table className="mt-4 border w-full max-h-[65vh]">
            <tr className="bg-primary">
              <th className="text-center text-white p-2 border">
                No.
              </th>
              <th className="text-center text-white p-2 border">
                Name of Rater
              </th>
              {result?.questions?.map(pQuestion => {
                return <th className="text-center text-white p-2 border">
                  {pQuestion.questionText}
                </th>
              })}
              <th className="text-center text-white p-2 border">
                Total
              </th>
            </tr>

            {result?.raters?.map((vRater, vIndex) => {
              return <tr>
                <td className="p-2 border text-center">
                  {vIndex + 1}
                </td>
                <td className="p-2 border">
                  {vRater.raterName}
                </td>

                {result?.questions?.map(vQuestion => {
                  return <td className="p-2 border text-center">
                    {vRater.answers[vQuestion.questionID]}
                  </td>
                }) /* results?.questions?.map */}
                <td className="p-2 border text-center">
                  {vRater.total}
                </td>
              </tr>
            }) /* result?.raters?.map */}

            <tr className="bg-primary">
              <td colspan="2" className="text-center text-white p-2 border">Total</td>
              {result?.questions?.map(vQuestion => {
                return <th className="text-center text-white p-2 border">
                  {vQuestion.total}
                </th>
              })}
              <td className="text-center text-white p-2 border">{result?.total}</td>
            </tr>
          </table>

        </div>
      )}
    </>
  );
};

export default SimulationResultDetails;